import { render } from "./MenuButton.vue?vue&type=template&id=3bcbd95c"
import script from "./MenuButton.vue?vue&type=script&lang=js"
export * from "./MenuButton.vue?vue&type=script&lang=js"
script.render = render

export default script